import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['bar', 'reward', 'input', 'placeholder', 'wrapper'];
  static values = { rewards: Array, offset: Number };

  updateProgress() {
    this.currentAmount = parseInt(this.inputTarget.value) || 0;
    this.barTarget.style.width = `${this.amount_to_percentage()}%`;

    this.rewardTargets.forEach((reward) => {
      const amount = parseInt(reward.dataset.amount);

      if (this.currentAmount >= amount) {
        reward.querySelector('.dot').classList.add('opacity-0', this.currentAmount >= amount);
        reward.querySelector('.gift-icon').classList.remove('text-slate-500');
        reward.querySelector('.gift-icon').classList.add('text-secondary');
        reward.querySelector('.circle').classList.remove('d-none');
        reward.querySelector('.check').classList.remove('d-none');
        reward.querySelector('.threshold').classList.remove('text-slate-500');
        reward.querySelector('.threshold').classList.add('text-secondary');
      } else {
        reward.querySelector('.dot').classList.remove('opacity-0');
        reward.querySelector('.gift-icon').classList.add('text-slate-500');
        reward.querySelector('.gift-icon').classList.remove('text-secondary');
        reward.querySelector('.circle').classList.add('d-none');
        reward.querySelector('.check').classList.add('d-none');
        reward.querySelector('.threshold').classList.add('text-slate-500');
        reward.querySelector('.threshold').classList.remove('text-secondary');
      }
    });

    this.placeholderTarget.textContent = this.earned_reward()?.reward || '';

    this.wrapperTarget.classList.toggle('d-none', this.earned_rewards_count() <= 0);
    this.wrapperTarget.classList.toggle('d-flex', this.earned_rewards_count() > 0);
  }

  minRewardAmount() {
    return this.rewardsValue[0].amount;
  }

  maxRewardAmount() {
    return this.rewardsValue[this.rewardsValue.length - 1].amount;
  }

  earned_rewards_count() {
    return this.rewardsValue.filter(
      (reward) => this.currentAmount >= reward.amount
    ).length;
  }

  earned_reward() {
    return this.rewardsValue
      .filter((reward) => this.currentAmount >= reward.amount)
      .pop();
  }

  amount_to_percentage() {
    if (this.currentAmount === 0) return 0;
    if (this.currentAmount >= this.maxRewardAmount()) return 100;

    const offset = this.offsetValue;
    const earned_rewards_count = this.earned_rewards_count();
    const percentage =
      offset + ((100 - offset * 2) / 4) * (earned_rewards_count - 1);

    return percentage;
  }
}
